import { format, parseISO } from "date-fns";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";

@Component({ name: "MessageView" })
export default class MessageView extends Vue {
  @Prop({ required: true })
  public message!: Message;

  @Prop({ type: String, required: true })
  public authUserId!: string;

  public get hoursMinutes() {
    return format(parseISO(this.message.time), "HH:mm");
  }

  public get opponentMessage() {
    return this.message.senderId !== this.authUserId;
  }

  public mounted() {
    this.$emit("rendered", { el: this.$el });
  }
}
